import VaultKeyList from "./VaultKeyList/VaultKeyList";

const Home = () => {
  return (
    <>
      <div>
        <VaultKeyList initialKeys={[]} />
      </div>
    </>
  );
};

export default Home;
